<template>
    <div>
        <el-form :inline="true" :model="searchForm" ref="searchForm">
            <el-form-item label="地区" prop="province" label-width="60px">
                <el-input v-model="province" placeholder="搜索地区" clearable> </el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getList">搜索</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="success" @click="resetForm('searchForm')">重置</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain @click="openVisiable(0)">添加</el-button>
            </el-form-item>
        </el-form>

        <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" border stripe style="width: 600px"
            max-height="800">
            <el-table-column align="center" label="地区" prop="province" width="200px"></el-table-column>
            <el-table-column align="center" label="首重1kg费用" prop="firstKilogramPrice" width="130px"></el-table-column>
            <el-table-column align="center" label="每续重1kg费用" prop="increaseKilogramsPrice"
                width="130px"></el-table-column>
            <el-table-column prop="icon" align="center" fixed="right" label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" plain size="mini" @click="openVisiable(1, scope.row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 对话框 -->
        <el-dialog title="添加运费" :visible.sync="dialogVisible" :rules="rules" width="30%" :before-close="handleClose">
            <el-form :model="editForm" ref="editForm" :rules="rules" label-width="130px" class="demo-editForm">
                <el-form-item label="地区" prop="province" >
                    <el-input v-model="editForm.province" placeholder="地区" :disabled="this.key == 1" clearable> </el-input>
                </el-form-item>
                <el-form-item label="首重1kg费用" prop="firstKilogramPrice">
                    <el-input type="munber" v-model.number="editForm.firstKilogramPrice" placeholder="首重1kg费用"
                        clearable>
                    </el-input>
                </el-form-item>
                <el-form-item label="每续重1kg费用" prop="increaseKilogramsPrice">
                    <el-input type="munber" v-model.number="editForm.increaseKilogramsPrice" placeholder="每续重1kg费用"
                        clearable>
                    </el-input>
                </el-form-item>
                <el-form-item align="center">
                    <el-button type="primary" @click="submitForm('editForm')">
                        提交
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>

export default {
    data() {
        return {
            //搜索数据
            province: "",
            editForm: {
                id: '',
                province: '',
                firstKilogramPrice: '',
                increaseKilogramsPrice: ''
            },
            key: 0,
            tableData: [],
            // typeList: [
            //     { name: '待审核', id: 0 },
            //     { name: '审核通过', id: 1 },
            //     { name: '审核驳回', id: 2 },
            //     { name: '转账成功', id: 3 }
            // ],
            //对话框是否展示
            dialogVisible: false,
            rules: {
                province: [
                    { required: true, message: '请输入地区', trigger: 'blur' }
                ],
                firstKilogramPrice: [
                    { required: true, message: '请输入首重1kg费用', trigger: 'blur' },
                    { type: 'number', message: '费用必须为数字值' }
                ],
                increaseKilogramsPrice: [
                    { required: true, message: '请输入每续重1kg费用', trigger: 'blur' },
                    { type: 'number', message: '费用必须为数字值' }
                ]
            }
        }
    },
    created() {
        this.getList()
    },
    methods: {
        resetForm(formName) {
            this.province=''
            this.getList()
        },
        // 关闭对话框触发事件
        handleClose() {
            this.dialogVisible = false
            this.resetForm('editForm')
            this.$refs.editForm.resetFields()
            this.editForm = {
                id: '',
                province: '',
                firstKilogramPrice: '',
                increaseKilogramsPrice: ''
            }
        },
        //列表
        getList() {
            this.$axios.get(`/admin/freightCharge/selectFreightChargeList?province=${this.province}`).then((res) => {
                console.log(33333333, res);
                if (res.code == 0) {
                    this.tableData = res.data
                }
            })
        },
        openVisiable(key, row) {
            this.key = key
            if (key == 1) {
                this.editForm = {
                    id: row.id,
                    province: row.province,
                    firstKilogramPrice: row.firstKilogramPrice,
                    increaseKilogramsPrice: row.increaseKilogramsPrice
                }
            }
            this.dialogVisible = true
        },
        submitForm() {
            this.$refs.editForm.validate((valid) => {
                if (valid) {
                    console.log(this.editForm);
                    if (this.key == 0) {
                        this.$axios.post('/admin/freightCharge/insertFreightCharge', this.editForm).then((res) => {
                            if (res.code == 0) {
                                this.getList()
                                this.handleClose()
                                this.$message({
                                    showClose: true,
                                    message: '恭喜你，操作成功',
                                    type: 'success',
                                })
                            }
                        })
                    } else {
                        this.$axios.post('/admin/freightCharge/updateFreightCharge', this.editForm).then((res) => {
                            if (res.code == 0) {
                                this.getList()
                                this.handleClose()
                                this.$message({
                                    showClose: true,
                                    message: '恭喜你，操作成功',
                                    type: 'success',
                                })
                            }
                        })
                    }
                }
            });
        },
    },
}
</script>

<style scoped></style>